const VivoUrl = process.env.REACT_APP_VIVO_URL;
const VivoApiUrl = process.env.REACT_APP_VIVO_API_URL;
// CONTROLLERS
const Controller_Recipes = "RecipeApi";
const Controller_Login = "VivoLoginApi";
const Controller_Common = "VivoCommonApi";
const Controller_InkSeries = "v2/InkSeriesApi";
const Controller_Components = "v2/ComponentApi";
const Controller_Orders = "v2/OrderApi";
const Controller_Members = "v2/MemberApi";
const Controller_Customers = "v2/CustomerApi";
const Controller_Attachments = "v2/AttachmentsApi";
const Controller_DownloadReport = "v2/DownloadReportApi";
const Controller_Reports = "ReportsApi";
const Controller_Labs = "v2/LabApi";
const Controller_Mailing = "v2/EmailSenderApi";
const Controller_EmailGroup = "v2/EmailGroupApi";
const Controller_Upload = "v2/UploadApi";
const Controller_Charts = "v2/ChartsApi";
const Controller_JobAssignment = "v2/JobAssignmentApi";
const Controller_WorkEvaluation = "v2/WorkEvaluationApi";
const Controller_ListManagement = "v2/ListManagementApi";
const Controller_ProductCodes = "v2/ProductCodesApi";


//export const ApiUrl_SignalR_ProgressHub = `${VivoUrl}/umbraco/progresshub?aid=abc`;
export const ApiUrl_SignalR_ProgressHub = `${VivoUrl}/umbraco/progresshub`;
export const ApiUrl_SignalR_CommentHub = `${VivoUrl}/umbraco/commenthub`;

// ENDPOINTS
// == Reports
export const ApiUrl_Reports_Service = `${VivoUrl}/api/${Controller_Reports}`
// == RecipeApi
export const ApiUrl_Recipes_RecipeList = `${VivoApiUrl}/${Controller_Recipes}/Recipes_Read`;
export const ApiUrl_Recipes_RecipeGet = `${VivoApiUrl}/${Controller_Recipes}/GetRecipe`;
export const ApiUrl_Recipes_RecipePrintGet = `${VivoApiUrl}/${Controller_Recipes}/GetRecipePrint`;
export const ApiUrl_Recipes_UpdateRecipe = `${VivoApiUrl}/${Controller_Recipes}/UpdateRecipe`;
export const ApiUrl_Recipes_CreateRecipeRevision = `${VivoApiUrl}/${Controller_Recipes}/CreateRecipeVersion`;
export const ApiUrl_Recipes_GetDropDownLists = `${VivoApiUrl}/${Controller_Recipes}/GetDropDownLists`;

// == Login
export const ApiUrl_Login_Login = `${VivoApiUrl}/${Controller_Login}/LoginMember`;
export const ApiUrl_Login_ImpersonateMember = `${VivoApiUrl}/${Controller_Login}/ImpersonateMember`;
export const ApiUrl_Login_Logout = `${VivoApiUrl}/${Controller_Login}/LogoutMember`;
export const ApiUrl_Login_VerifyMember = `${VivoApiUrl}/${Controller_Login}/VerifyUser`;
export const ApiUrl_Login_ExchangeOneLoginToken = `${VivoApiUrl}/${Controller_Login}/ExchangeOneLoginToken`;

// == Common
export const ApiUrl_Common_SwitchLab = `${VivoApiUrl}/${Controller_Common}/SwitchLab`;
export const ApiUrl_Common_SwitchDivision = `${VivoApiUrl}/${Controller_Common}/SwitchDivision`;

// == InkSeries
export const ApiUrl_InkSeries_InkSeriesList = `${VivoApiUrl}/${Controller_InkSeries}/InkSeriesList_Read`;
export const ApiUrl_InkSeries_Get = `${VivoApiUrl}/${Controller_InkSeries}/Get`;
export const ApiUrl_InkSeries_GetFilteredCompanies = `${VivoApiUrl}/${Controller_InkSeries}/GetFilteredCompanies`;
export const ApiUrl_InkSeries_SaveAndPropagate = `${VivoApiUrl}/${Controller_InkSeries}/SaveAndPropagate`;
export const ApiUrl_InkSeries_SaveAsChild = `${VivoApiUrl}/${Controller_InkSeries}/SaveAsChild`;
export const ApiUrl_InkSeries_UpdateCompaniesAssignedToSeries = `${VivoApiUrl}/${Controller_InkSeries}/UpdateCompaniesAssignedToSeries`;
export const ApiUrl_InkSeries_Delete = `${VivoApiUrl}/${Controller_InkSeries}/Delete`;

// == COMPONENTS
export const ApiUrl_Components_ComponentList = `${VivoApiUrl}/${Controller_Components}/ComponentList_Read`;
export const ApiUrl_Components_Get = `${VivoApiUrl}/${Controller_Components}/Get`;
export const ApiUrl_Components_Save = `${VivoApiUrl}/${Controller_Components}/Save`;
export const ApiUrl_Components_Delete = `${VivoApiUrl}/${Controller_Components}/Delete`;
export const ApiUrl_Components_GetByName = `${VivoApiUrl}/${Controller_Components}/GetByName`;
export const ApiUrl_Components_ImportComponents = `${VivoApiUrl}/${Controller_Components}/ImportComponents`;

// == MEMBERS
export const ApiUrl_Members_SearchUser = `${VivoApiUrl}/${Controller_Members}/SearchUser`;
export const ApiUrl_Members_GetView = `${VivoApiUrl}/${Controller_Members}/GetView`;
export const ApiUrl_Members_MemberList_Read = `${VivoApiUrl}/${Controller_Members}/MemberList_Read`;
export const ApiUrl_Members_Get = `${VivoApiUrl}/${Controller_Members}/Get`;
export const ApiUrl_Members_GetMyProfile = `${VivoApiUrl}/${Controller_Members}/GetMyProfile`;
export const ApiUrl_Members_AddUserCategory = `${VivoApiUrl}/${Controller_Members}/AddUserCategory`;
export const ApiUrl_Members_Update = `${VivoApiUrl}/${Controller_Members}/Update`;
export const ApiUrl_Members_LockUnlockMember = `${VivoApiUrl}/${Controller_Members}/LockUnlockMember`;
export const ApiUrl_Members_ResetPassword = `${VivoApiUrl}/${Controller_Members}/ResetPassword`;
export const ApiUrl_Members_ResetQAndA = `${VivoApiUrl}/${Controller_Members}/ResetQAndA`;
export const ApiUrl_Members_GetAdminSupervisorList = `${VivoApiUrl}/${Controller_Members}/GetAdminSupervisorList`;
export const ApiUrl_Members_GetSettings = `${VivoApiUrl}/${Controller_Members}/GetSettings`;
export const ApiUrl_Members_SaveSettings = `${VivoApiUrl}/${Controller_Members}/SaveSettings`;
// == CUSTOMERS
export const ApiUrl_Customers_CustomerList_Read = `${VivoApiUrl}/${Controller_Customers}/CustomerList_Read`;
export const ApiUrl_Customers_CustomerListForUser_Read = `${VivoApiUrl}/${Controller_Customers}/CustomerListForUser_Read`;
export const ApiUrl_Customers_Get = `${VivoApiUrl}/${Controller_Customers}/Get`;
export const ApiUrl_Customers_Save = `${VivoApiUrl}/${Controller_Customers}/Save`;
export const ApiUrl_Customers_Delete = `${VivoApiUrl}/${Controller_Customers}/Delete`;
// == ORDERS
export const ApiUrl_Orders_GetOrderListView = `${VivoApiUrl}/${Controller_Orders}/GetOrderListView`;
export const ApiUrl_Orders_OrderList = `${VivoApiUrl}/${Controller_Orders}/OrderList_Read`;
export const ApiUrl_Orders_ProjectList = `${VivoApiUrl}/${Controller_Orders}/ProjectList_Read`;
export const ApiUrl_Orders_GetJobsRequiredTooltip = `${VivoApiUrl}/${Controller_Orders}/GetJobsRequiredTooltip`;
export const ApiUrl_Orders_GetJobsTooltip = `${VivoApiUrl}/${Controller_Orders}/GetJobsTooltip`;
export const ApiUrl_Orders_GetOrderSummaryTooltip = `${VivoApiUrl}/${Controller_Orders}/GetOrderSummaryTooltip`;
export const ApiUrl_Orders_GetOrderPreview = `${VivoApiUrl}/${Controller_Orders}/GetOrderPreview`;
export const ApiUrl_Orders_ToggleOrderFlag = `${VivoApiUrl}/${Controller_Orders}/ToggleOrderFlag`;
export const ApiUrl_Orders_MarkOrderAsProject = `${VivoApiUrl}/${Controller_Orders}/MarkOrderAsProject`;
export const ApiUrl_Orders_UnMarkOrderAsProject = `${VivoApiUrl}/${Controller_Orders}/UnMarkOrderAsProject`;
export const ApiUrl_Orders_AcceptUnacceptedOrder = `${VivoApiUrl}/${Controller_Orders}/AcceptUnacceptedOrder`;
export const ApiUrl_Orders_AssignProjectLeader = `${VivoApiUrl}/${Controller_Orders}/AssignProjectLeader`;
export const ApiUrl_Orders_StartWork = `${VivoApiUrl}/${Controller_Orders}/StartWork`;
export const ApiUrl_Orders_ReportOrderActivities = `${VivoApiUrl}/${Controller_Orders}/ReportOrderActivities`;
export const ApiUrl_Orders_UpdateColourStandardProcessInfo = `${VivoApiUrl}/${Controller_Orders}/UpdateColourStandardProcessInfo`;
export const ApiUrl_Orders_UpdateOrderProgress = `${VivoApiUrl}/${Controller_Orders}/UpdateOrderProgress`;
export const ApiUrl_Orders_SuspendOrder = `${VivoApiUrl}/${Controller_Orders}/SuspendOrder`;
export const ApiUrl_Orders_RejectOrder = `${VivoApiUrl}/${Controller_Orders}/RejectOrder`;
export const ApiUrl_Orders_DelegateOrder = `${VivoApiUrl}/${Controller_Orders}/DelegateOrder`;
export const ApiUrl_Orders_UpdateProjectLeader = `${VivoApiUrl}/${Controller_Orders}/UpdateProjectLeader`;
export const ApiUrl_Orders_UpdateConfirmedDate = `${VivoApiUrl}/${Controller_Orders}/UpdateConfirmedDate`;
export const ApiUrl_Orders_CompleteOrderProcess = `${VivoApiUrl}/${Controller_Orders}/CompleteOrderProcess`;
export const ApiUrl_Orders_GetCoordinatorList = `${VivoApiUrl}/${Controller_Orders}/GetCoordinatorList`;
export const ApiUrl_Orders_AssignCoordinator = `${VivoApiUrl}/${Controller_Orders}/AssignCoordinator`;
export const ApiUrl_Orders_ApproveByCoordinator = `${VivoApiUrl}/${Controller_Orders}/ApproveByCoordinator`;
export const ApiUrl_Orders_SendForFinalApproval = `${VivoApiUrl}/${Controller_Orders}/SendForFinalApproval`;
export const ApiUrl_Orders_RejectByCoordinator = `${VivoApiUrl}/${Controller_Orders}/RejectByCoordinator`;
export const ApiUrl_Orders_FinallyApproveByCoordinator = `${VivoApiUrl}/${Controller_Orders}/FinallyApproveByCoordinator`;
export const ApiUrl_Orders_AddTrackingNumber = `${VivoApiUrl}/${Controller_Orders}/AddTrackingNumber`;
export const ApiUrl_Orders_DeleteTrackingNumber = `${VivoApiUrl}/${Controller_Orders}/DeleteTrackingNumber`;
export const ApiUrl_Orders_UpdatePendingTrackingNumber = `${VivoApiUrl}/${Controller_Orders}/UpdatePendingTrackingNumber`;
export const ApiUrl_Orders_DeleteComment = `${VivoApiUrl}/${Controller_Orders}/DeleteComment`;
export const ApiUrl_Orders_GetComments = `${VivoApiUrl}/${Controller_Orders}/GetComments`;
export const ApiUrl_Orders_UpdateComment = `${VivoApiUrl}/${Controller_Orders}/UpdateComment`;
export const ApiUrl_Orders_AddComment = `${VivoApiUrl}/${Controller_Orders}/AddComment`;
export const ApiUrl_Orders_GetOrderReportData = `${VivoApiUrl}/${Controller_Orders}/GetOrderReportData`;
export const ApiUrl_Orders_GetSerialOrderReportData = `${VivoApiUrl}/${Controller_Orders}/GetSerialOrderReportData`;
export const ApiUrl_Orders_VerifyRccAttachments = `${VivoApiUrl}/${Controller_Orders}/VerifyRccAttachments`;
export const ApiUrl_Orders_GetMyUnreadComments = `${VivoApiUrl}/${Controller_Orders}/GetMyUnreadComments`;
export const ApiUrl_Orders_SetCommentReadPointer = `${VivoApiUrl}/${Controller_Orders}/SetCommentReadPointer`;
export const ApiUrl_Orders_SetCommentReadPointerBackInTime = `${VivoApiUrl}/${Controller_Orders}/SetCommentReadPointerBackInTime`;
export const ApiUrl_Orders_GetOrderEditView = `${VivoApiUrl}/${Controller_Orders}/GetOrderEditView`;
export const ApiUrl_Orders_GetPrepareFor = `${VivoApiUrl}/${Controller_Orders}/GetPrepareFor`;
export const ApiUrl_Orders_SetPrepareForCompany = `${VivoApiUrl}/${Controller_Orders}/SetPrepareForCompany`;
export const ApiUrl_Orders_SwitchProfile = `${VivoApiUrl}/${Controller_Orders}/SwitchProfile`;
export const ApiUrl_Orders_SavaOrderEdit = `${VivoApiUrl}/${Controller_Orders}/SavaOrderEdit`;

// == ATTACHMENTS
export const ApiUrl_Attachments_GetMyAttachmentsView = `${VivoApiUrl}/${Controller_Attachments}/GetMyAttachmentsView`;
export const ApiUrl_Attachments_MyFilesList_Read = `${VivoApiUrl}/${Controller_Attachments}/MyFilesList_Read`;
export const ApiUrl_Attachments_DownloadAttachment = `${VivoApiUrl}/${Controller_Attachments}/DownloadAttachment`;
export const ApiUrl_Attachments_DownloadAttachments = `${VivoApiUrl}/${Controller_Attachments}/DownloadAttachments`;
export const ApiUrl_Attachments_GetForOrder = `${VivoApiUrl}/${Controller_Attachments}/GetForOrder`;
export const ApiUrl_Attachments_Delete = `${VivoApiUrl}/${Controller_Attachments}/Delete`;
export const ApiUrl_Attachments_UnDelete = `${VivoApiUrl}/${Controller_Attachments}/UnDelete`;

// == DOWNLOAD REPORT

export const ApiUrl_DownloadReport_GetUserList = `${VivoApiUrl}/${Controller_DownloadReport}/GetUserList`;
export const ApiUrl_DownloadReport_ExportCustomers = `${VivoApiUrl}/${Controller_DownloadReport}/ExportCustomers`;
export const ApiUrl_DownloadReport_GetOrderListReport = `${VivoApiUrl}/${Controller_DownloadReport}/GetOrderListReport`;
export const ApiUrl_DownloadReport_GetCsvReportPage = `${VivoApiUrl}/${Controller_DownloadReport}/GetCsvReportPage`;
export const ApiUrl_DownloadReport_GetCsvReport = `${VivoApiUrl}/${Controller_DownloadReport}/GetCsvReport`;
export const ApiUrl_Old_DownloadReport_QueryBrandColorReport = `${VivoApiUrl}/v2/ChartApi/QueryBrandColorReport`;
export const ApiUrl_DownloadReport_DownloadFilteredUserList = `${VivoApiUrl}/${Controller_DownloadReport}/DownloadFilteredUserList`;

// == LABS
export const ApiUrl_Labs_GetLabList = `${VivoApiUrl}/${Controller_Labs}/GetLabList`;
export const ApiUrl_Labs_Get = `${VivoApiUrl}/${Controller_Labs}/Get`;
export const ApiUrl_Labs_SaveLab = `${VivoApiUrl}/${Controller_Labs}/SaveLab`;

// == MAILING
export const ApiUrl_EmailSender_EmailSenderList_Read = `${VivoApiUrl}/${Controller_Mailing}/EmailSenderList_Read`;
export const ApiUrl_EmailSender_GetDetailsView = `${VivoApiUrl}/${Controller_Mailing}/GetDetailsView`;
export const ApiUrl_EmailSender_SendMassiveEmail = `${VivoApiUrl}/${Controller_Mailing}/SendMassiveEmail`;
export const ApiUrl_EmailSender_EmailSenderReport_Read = `${VivoApiUrl}/${Controller_Mailing}/EmailSenderReport_Read`;

// == EMAIL GROUPS
export const ApiUrl_EmailGroup_EmailGroupList_Read = `${VivoApiUrl}/${Controller_EmailGroup}/EmailGroupList_Read`;// == EMAIL GROUPS

// == UPLOAD
export const ApiUrl_Upload_UploadFile = `${VivoApiUrl}/${Controller_Upload}/UploadFile`;
export const ApiUrl_Upload_RemoveFile = `${VivoApiUrl}/${Controller_Upload}/RemoveFile`;
export const ApiUrl_Upload_ImportCustomers = `${VivoApiUrl}/${Controller_Upload}/ImportCustomers`;

// == CHARTS
export const ApiUrl_Charts_GetJobStatisticsView = `${VivoApiUrl}/${Controller_Charts}/GetJobStatisticsView`;
export const ApiUrl_Charts_QueryJobStatisticsData = `${VivoApiUrl}/${Controller_Charts}/QueryJobStatisticsData`;
export const ApiUrl_Charts_GetJobsPercentageView = `${VivoApiUrl}/${Controller_Charts}/GetJobsPercentageView`;
export const ApiUrl_Charts_QueryJobsPercentageData = `${VivoApiUrl}/${Controller_Charts}/QueryJobsPercentageData`;
export const ApiUrl_Charts_GetDelayStatisticsView = `${VivoApiUrl}/${Controller_Charts}/GetDelayStatisticsView`;
export const ApiUrl_Charts_QueryDelayStatisticsData = `${VivoApiUrl}/${Controller_Charts}/QueryDelayStatisticsData`;
export const ApiUrl_Charts_QueryRftFullReport = `${VivoApiUrl}/${Controller_Charts}/QueryRftFullReport`;

// == JOB ASSIGNMENT
export const ApiUrl_Charts_JobAssignmentList_Read = `${VivoApiUrl}/${Controller_JobAssignment}/JobAssignmentList_Read`;

// == WORK EVALUATION
export const ApiUrl_WorkEvaluation_WorkEvaluationList_Read = `${VivoApiUrl}/${Controller_WorkEvaluation}/WorkEvaluationList_Read`;
export const ApiUrl_WorkEvaluation_GetListPageView = `${VivoApiUrl}/${Controller_WorkEvaluation}/GetListPageView`;
export const ApiUrl_WorkEvaluation_Delete = `${VivoApiUrl}/${Controller_WorkEvaluation}/Delete`;
export const ApiUrl_WorkEvaluation_LockRange = `${VivoApiUrl}/${Controller_WorkEvaluation}/LockRange`;


// == LIST MANAGEMENT
export const ApiUrl_ListManagement_GetView = `${VivoApiUrl}/${Controller_ListManagement}/GetView`;
export const ApiUrl_ListManagement_Save = `${VivoApiUrl}/${Controller_ListManagement}/Save`;
export const ApiUrl_ListManagement_CloneFromLab = `${VivoApiUrl}/${Controller_ListManagement}/CloneFromLab`;


// == PRODUCT CODES
export const ApiUrl_ProductCodes_CodeList_Read = `${VivoApiUrl}/${Controller_ProductCodes}/CodeList_Read`;
export const ApiUrl_ProductCodes_Delete = `${VivoApiUrl}/${Controller_ProductCodes}/Delete`;
export const ApiUrl_ProductCodes_Get = `${VivoApiUrl}/${Controller_ProductCodes}/Get`;
